<template>
  <div>
    <transition name="slide">
      <div
        v-if="window.width >= 800 || sideMenu"
        id="admin-mobile-navigation"
        class="sidenav-main"
        :style="portalThemeStyles"
      >
        <div class="brand-header">
          <button
            v-if="window.width < 800"
            type="button"
            class="side-menu-close"
            aria-label="Cerrar menú de navegación"
            @click="CambiarMenuAction({})"
          >
            <b-icon icon="x" aria-hidden="true" />
          </button>
          <div class="brand-logo-frame">
            <img
              :src="window.width < 800 ? mobileBrandLogo : brandLogo"
              class="brand-logo"
              alt="Jobbing"
            />
          </div>
          <div class="brand-divider"></div>
        </div>
        
        <div v-if="admin_datos.user_type == 'jobbing_admin'" class="main-scrollable">
          <div class="nav-label">Navegación</div>
          <ul>
            <router-link v-if="admin_datos.superadmin" tag="li" to="/Dashboard">
              <b-icon icon="layout-split" class="arrows" />Dashboard
            </router-link>

            <router-link v-else tag="li" to="/">
              <b-icon icon="layout-split" class="arrows" />Inicio
            </router-link>
            <router-link tag="li" to="/Reportes" class="menu-item">
              <b-icon icon="graph-up" class="arrows" />
              <span class="menu-label">Estadísticas</span>
            </router-link>
            <router-link v-if="admin_datos.superadmin" tag="li" to="/superadmin/Mailing">
              <b-icon icon="mailbox" class="arrows" />Mailing
            </router-link>

            <router-link tag="li" to="/VerProfesionales">
              <b-icon icon="person-fill" class="arrows" />Profesionales
            </router-link>
            <router-link v-if="admin_datos.superadmin" tag="li" to="/superadmin/Usuarios">
              <b-icon icon="people" class="arrows" />Usuarios
            </router-link>
            <router-link v-if="admin_datos.superadmin" tag="li" to="/superadmin/Grabaciones">
              <b-icon icon="mic" class="arrows" />Grabaciones
            </router-link>
            <router-link v-if="admin_datos.superadmin" tag="li" to="/superadmin/AsistenteIA">
              <b-icon icon="chat-dots" class="arrows" />Asistente IA
            </router-link>
            <router-link tag="li" to="/Ordenes">
              <b-icon icon="cash" class="arrows" />Ordenes
            </router-link>
            <router-link tag="li" to="/Mapa">
              <b-icon icon="map" class="arrows" />Mapa
            </router-link>
            <router-link tag="li" to="/ObtenerApp">
              <b-icon icon="phone" class="arrows" />Obtener App
            </router-link>
            <!-- <li><b-icon icon="globe" class="icons" />Información general</li> -->
          </ul>
          <div class="nav-label">Empresa</div>
          <ul>
            <!-- <li><b-icon icon="person" class="icons" />Por profesional</li>-->
            <!--<li><b-icon icon="gear" class="icons" />Por Máquina</li>-->
            <!-- <router-link tag="li" to="/Profile" ><b-icon icon="person" class="arrows" />Perfil </router-link> -->
            <router-link v-if="admin_datos.superadmin" tag="li" to="/superadmin/Pagos">
              <b-icon icon="truck" class="arrows" />Pagos a proveedores
            </router-link>
            <router-link v-if="admin_datos.superadmin" tag="li" to="/superadmin/DocumentosTributariosComisiones">
              <b-icon icon="file-earmark-text" class="arrows" />Documentos tributarios
            </router-link>
            <router-link v-if="admin_datos.superadmin" tag="li" to="/superadmin/Transferencias">
              <b-icon icon="cash-coin" class="arrows" />Transferencias
            </router-link>
            <router-link v-if="admin_datos.superadmin" tag="li" to="/superadmin/PagosAgrupados">
              <b-icon icon="folder-check" class="arrows" />Pagos agrupados
            </router-link>
            <router-link v-if="admin_datos.superadmin" tag="li" to="/superadmin/ResponderSolicitudes">
              <b-icon icon="reply" class="arrows" />Responder solicitudes
            </router-link>
            <router-link v-if="admin_datos.superadmin" tag="li" to="/superadmin/Blog">
              <b-icon icon="newspaper" class="arrows" />Blog
            </router-link>
            <router-link v-if="admin_datos.superadmin" tag="li" to="/superadmin/GuiaPrecios">
              <b-icon icon="currency-dollar" class="arrows" />Guia de Precios
            </router-link>
            <router-link v-if="admin_datos.superadmin" tag="li" to="/superadmin/Descuentos">
              <b-icon icon="tag" class="arrows" />Descuentos
            </router-link>
            <router-link v-if="admin_datos.superadmin" tag="li" to="/superadmin/LeadPartnersManagement">
              <b-icon icon="people-fill" class="arrows" />Partners y pagos
            </router-link>
            <router-link v-if="admin_datos.superadmin" tag="li" to="/superadmin/Beneficios">
              <b-icon icon="gift" class="arrows" />Beneficios
            </router-link>
            <router-link v-if="admin_datos.superadmin" tag="li" to="/superadmin/CatalogoServicios"><b-icon icon="list-check" class="arrows" />Catálogo de servicios</router-link>
            <router-link v-if="admin_datos.superadmin" tag="li" to="/superadmin/SuscripcionesProfesionales">
              <b-icon icon="credit-card" class="arrows" />Planes de profesionales
            </router-link>
            <router-link v-if="admin_datos.superadmin" tag="li" to="/superadmin/DeudaEmpresas">
              <b-icon icon="currency-dollar" class="arrows" />Deuda Empresas
            </router-link>
            <router-link v-if="admin_datos.superadmin" tag="li" to="/superadmin/Aplicante">
              <b-icon icon="person" class="arrows" />Aplicantes
            </router-link>
            <router-link v-if="admin_datos.superadmin" tag="li" to="/superadmin/Whatsapps">
              <b-icon icon="whatsapp" class="arrows" />WhatsApps
            </router-link>
            <router-link v-if="admin_datos.superadmin" tag="li" to="/superadmin/Encuestas">
              <b-icon icon="chat-right-text" class="arrows" />Encuestas
            </router-link>
          </ul>
          <div class="nav-label">Administradores de Propiedades</div>
          <ul>
            <router-link v-if="admin_datos.superadmin" tag="li" to="/superadmin/PropertyManagerManagement">
              <b-icon icon="house" class="arrows" />Administradores
            </router-link>
            <router-link v-if="admin_datos.superadmin" tag="li" to="/superadmin/EmpresaAdministracionManagement">
              <b-icon icon="building" class="arrows" />Empresas
            </router-link>
            <router-link v-if="admin_datos.superadmin" tag="li" to="/superadmin/AsignarProfesionales">
              <b-icon icon="person" class="arrows" />Asignar profesionales
            </router-link>
            <router-link v-if="admin_datos.superadmin" tag="li" to="/superadmin/PagoEmpresasAdministracion">
              <b-icon icon="truck" class="arrows" />Pago a Empresa
            </router-link>
            <router-link tag="li" to="/administrador-propiedades/Solicitudes">
              <b-icon icon="clipboard-data" class="arrows" />Datos
            </router-link>
          </ul>
          <br />
          <!--
      <div >
       <div class="nav-label">
        Configuración
      </div>
      <ul>
        <li :class="sucursales ? 'liclicked': ''" v-on:click="sucursales=!sucursales"><b-icon icon="building" class="icons" />Sucursales <b-icon icon="caret-right" :class="sucursales ? 'miniarrowActive': 'miniarrow'"  /></li>
        <div class="subitems" :class="sucursales ? 'isActive':'isInActive'">
          <ul class="subul">
          <router-link tag="li" to="/AdministrarSucursal" ><b-icon icon="arrow-right-short" class="arrows" />Ver sucursales </router-link>
          <router-link tag="li" to="/AgregarSucursal" ><b-icon icon="arrow-right-short" class="arrows" />Crear sucursales  </router-link>

          </ul>
        </div>

        <router-link tag="li" to="/AdministrarPrestaciones" ><b-icon icon="journals" class="icons" />Prestaciones</router-link>
        <router-link tag="li" to="/AgregarFunciones" ><b-icon icon="tablet" class="arrows" />Funciones</router-link>
        <router-link tag="li" to="/AdministrarPersonal" ><b-icon icon="person" class="icons" />Personal</router-link>
        <router-link tag="li" to="/AdministrarMaquinas" ><b-icon icon="tv" class="icons" />Máquinas</router-link>
        <router-link tag="li" to="/AdministrarServicios" ><b-icon icon="shop-window" class="icons" />Servicios</router-link>
        <router-link tag="li" to="/Instituciones" ><b-icon icon="briefcase" class="icons" />Instituciones</router-link>
        <router-link tag="li" to="/AdministrarPrecios" ><b-icon icon="cash-stack" class="icons" />Precios</router-link>
        <router-link tag="li" to="/Configuracion" ><b-icon icon="gear" class="icons" />Configuraciones</router-link>

      </ul>
      </div>
-->
        </div>
        <div v-else-if="admin_datos.user_type == 'property_manager'" class="main-scrollable">
          <div class="nav-label">Navegación</div>
          <ul>
            <router-link tag="li" to="/">
              <b-icon icon="house" class="arrows" />Inicio
            </router-link>
            <router-link tag="li" to="/administrador-propiedades/Dashboard">
              <b-icon icon="layout-split" class="arrows" />Dashboard
            </router-link>
            <router-link tag="li" to="/administrador-propiedades/Estadisticas">
              <b-icon icon="graph-up" class="arrows" />Estadísticas
            </router-link>
            <router-link tag="li" to="/administrador-propiedades/Propiedades">
              <b-icon icon="house-door" class="arrows" />Propiedades
            </router-link>

            <router-link tag="li" to="/administrador-propiedades/Solicitudes">
              <b-icon icon="clipboard-data" class="arrows" />Datos
            </router-link>
            <router-link tag="li" to="/administrador-propiedades/ProfesionalesAdmPropiedades">
              <b-icon icon="person" class="arrows" />Profesionales
            </router-link>
            <router-link
              tag="li"
              to="/administrador-propiedades/CrearSolicitud"
              class="menu-item cta-link"
            >
              <b-icon icon="star" class="arrows" />
              <span class="menu-label">Nueva Solicitud</span>
            </router-link>

            <!-- <li><b-icon icon="globe" class="icons" />Información general</li> -->
          </ul>
          <div class="nav-label">Pendientes</div>
          <ul>
            <router-link tag="li" to="/administrador-propiedades/PagosPendientes" class="menu-item">
              <b-icon icon="credit-card" class="arrows" />
              <span class="menu-label">Pagos pendientes</span>
              <span v-if="shouldShowPendingPaymentsBadge" class="pending-payments-badge">
                {{ pendingPaymentsBadge }}
              </span>
            </router-link>
            <router-link
              tag="li"
              to="/administrador-propiedades/PresupuestosPendientes"
              class="menu-item"
            >
              <b-icon icon="clipboard-check" class="arrows" />
              <span class="menu-label">Presupuestos pendientes</span>
              <span v-if="shouldShowPendingBudgetsBadge" class="pending-payments-badge">
                {{ pendingBudgetsBadge }}
              </span>
            </router-link>
          </ul>
        </div>
        <div v-else-if="admin_datos.user_type == 'lead_partner'" class="main-scrollable">
          <div class="nav-label">Navegación</div>
          <ul>
            <router-link tag="li" to="/">
              <b-icon icon="house" class="arrows" />Inicio
            </router-link>
            <router-link tag="li" to="/lead-partner/Dashboard">
              <b-icon icon="layout-split" class="arrows" />Dashboard
            </router-link>
            <router-link tag="li" to="/lead-partner/Estadisticas">
              <b-icon icon="graph-up" class="arrows" />Estadísticas
            </router-link>
          </ul>
        </div>
      </div>
    </transition>
    <div
      v-on:click="CambiarMenuAction({})"
      v-if="window.width < 800 && sideMenu"
      class="sidenav-overlay"
      aria-hidden="true"
    ></div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'SideNav',
  components: {},
  data() {
    return {
      sucursales: false,
      prestaciones: false,
      funciones: false,
      recursos: false,
      presonal: false,
      maquinas: false,
      window: {
        width: 0,
        height: 0,
      },
    };
  },
  mounted() {},
  computed: {
    ...mapGetters({
      admin_datos: 'admin_datos',
      isLoggedIn: 'isLoggedIn',
      sideMenu: 'sideMenu',
      pendingPaymentsCount: 'propertyManagerPendingPaymentsCount',
      pendingBudgetsCount: 'propertyManagerPendingBudgetsCount',
    }),
    isPropertyManager() {
      return this.admin_datos && this.admin_datos.user_type === 'property_manager';
    },
    shouldShowPendingPaymentsBadge() {
      if (!this.isPropertyManager) {
        return false;
      }

      const count = Number(this.pendingPaymentsCount);
      if (Number.isNaN(count)) {
        return false;
      }

      return count > 0;
    },
    pendingPaymentsBadge() {
      if (this.pendingPaymentsCount === null) {
        return '';
      }
      if (this.pendingPaymentsCount > 99) {
        return '99+';
      }
      return this.pendingPaymentsCount;
    },
    shouldShowPendingBudgetsBadge() {
      if (!this.isPropertyManager) {
        return false;
      }

      const count = Number(this.pendingBudgetsCount);
      if (Number.isNaN(count)) {
        return false;
      }

      return count > 0;
    },
    pendingBudgetsBadge() {
      if (this.pendingBudgetsCount === null) {
        return '';
      }
      if (this.pendingBudgetsCount > 99) {
        return '99+';
      }
      return this.pendingBudgetsCount;
    },
    tenantAtributos() {
      if (!this.admin_datos) {
        return null;
      }
      if (this.admin_datos.user_type === 'property_manager') {
        return this.admin_datos.empresa && this.admin_datos.empresa.atributos
          ? this.admin_datos.empresa.atributos
          : null;
      }
      if (this.admin_datos.user_type === 'lead_partner') {
        return this.admin_datos.lead_partner && this.admin_datos.lead_partner.atributos
          ? this.admin_datos.lead_partner.atributos
          : null;
      }
      return null;
    },
    brandLogo() {
      const atributos = this.tenantAtributos;
      const logo = atributos && (atributos.logo_filename || atributos.logo_url || atributos.logo);
      return logo || require('@/assets/logo-jobbing-nuevo.webp');
    },
    mobileBrandLogo() {
      const baseUrl = process.env.BASE_URL || '/';
      const normalizedBaseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
      return `${normalizedBaseUrl}favicon-192x192.png`;
    },
    tenantBrandColor() {
      const atributos = this.tenantAtributos;
      const color = atributos && atributos.color ? atributos.color : null;

      if (!this.isValidHexColor(color)) {
        return null;
      }

      return this.normalizeHexColor(color);
    },
    portalThemeStyles() {
      if (!this.tenantBrandColor) {
        return {};
      }

      const base = this.tenantBrandColor;
      const lighter = this.adjustColor(base, 0.16);
      const darker = this.adjustColor(base, -0.12);
      const activeStart = this.adjustColor(base, 0.08);
      const activeEnd = this.adjustColor(base, -0.18);

      return {
        '--pm-cta-color': base,
        '--pm-cta-gradient': `linear-gradient(135deg, ${lighter}, ${darker})`,
        '--pm-cta-gradient-active': `linear-gradient(135deg, ${activeStart}, ${activeEnd})`,
        '--pm-cta-shadow': `0 12px 24px ${this.hexToRgba(base, 0.28)}`,
        '--pm-cta-shadow-hover': `0 16px 30px ${this.hexToRgba(base, 0.35)}`,
      };
    },
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  watch: {
    admin_datos: {
      handler(newValue, oldValue) {
        if (newValue && newValue.user_type === 'property_manager') {
          if (this.pendingPaymentsCount === null) {
            this.fetchPropertyManagerPendingPaymentsCount();
          }
          if (this.pendingBudgetsCount === null) {
            this.fetchPropertyManagerPendingBudgetsCount();
          }
        } else if (oldValue && oldValue.user_type === 'property_manager') {
          this.resetPropertyManagerPendingPaymentsState();
          this.resetPropertyManagerPendingBudgetsState();
        }
      },
      immediate: true,
      deep: true,
    },
    $route(to) {
      if (this.window.width < 800 && this.sideMenu) {
        this.CambiarMenuAction({});
      }
      if (this.isPropertyManager && this.isPagosPendientesRoute(to) && this.pendingPaymentsCount === null) {
        this.fetchPropertyManagerPendingPaymentsCount();
      }
      if (this.isPropertyManager && this.isPresupuestosPendientesRoute(to) && this.pendingBudgetsCount === null) {
        this.fetchPropertyManagerPendingBudgetsCount();
      }
    },
  },
  methods: {
    ...mapActions([
      'CambiarMenuAction',
      'fetchPropertyManagerPendingPaymentsCount',
      'resetPropertyManagerPendingPaymentsState',
      'fetchPropertyManagerPendingBudgetsCount',
      'resetPropertyManagerPendingBudgetsState',
    ]),
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    isValidHexColor(color) {
      if (typeof color !== 'string') {
        return false;
      }
      const value = color.trim();
      return /^#?[0-9A-Fa-f]{3}([0-9A-Fa-f]{3})?$/.test(value);
    },
    normalizeHexColor(color) {
      if (!this.isValidHexColor(color)) {
        return null;
      }
      let hex = color.trim().replace('#', '');
      if (hex.length === 3) {
        hex = hex
          .split('')
          .map((char) => `${char}${char}`)
          .join('');
      }
      return `#${hex.toLowerCase()}`;
    },
    adjustColor(hex, ratio) {
      const normalized = this.normalizeHexColor(hex);
      if (!normalized) {
        return hex;
      }

      const clampRatio = Math.max(-1, Math.min(1, ratio));
      const integer = parseInt(normalized.slice(1), 16);
      const channels = [
        (integer >> 16) & 0xff,
        (integer >> 8) & 0xff,
        integer & 0xff,
      ];

      const adjustChannel = (channel) => {
        const delta = clampRatio >= 0 ? (255 - channel) * clampRatio : channel * clampRatio;
        return Math.max(0, Math.min(255, Math.round(channel + delta)));
      };

      const [r, g, b] = channels.map(adjustChannel);
      const toHex = (channel) => channel.toString(16).padStart(2, '0');

      return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    },
    hexToRgba(hex, alpha = 1) {
      const normalized = this.normalizeHexColor(hex);
      if (!normalized) {
        return `rgba(37, 99, 235, ${alpha})`;
      }
      const integer = parseInt(normalized.slice(1), 16);
      const r = (integer >> 16) & 0xff;
      const g = (integer >> 8) & 0xff;
      const b = integer & 0xff;
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
    isPagosPendientesRoute(route) {
      return route && route.path && route.path.includes('/administrador-propiedades/PagosPendientes');
    },
    isPresupuestosPendientesRoute(route) {
      return route && route.path && route.path.includes('/administrador-propiedades/PresupuestosPendientes');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.miniarrow {
  float: right;
  margin-right: 20px;
  transition-duration: 0.25s;
}
.miniarrowActive {
  float: right;
  margin-right: 20px;
  color: white;
  transform: rotate(90deg);
  transition-duration: 0.25s;
}

.liclicked {
  background-color: rgb(29, 37, 48) !important;
  color: white !important;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: rgb(38, 53, 67);
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(23, 32, 40);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgb(23, 32, 40);
}

.arrows {
  font-size: 20px;
  margin-right: 10px;
  transform: translate(0px, 3px);
}
.subul {
  padding: 0px;
}
.main-scrollable {
  flex: 1 1 auto;
  min-height: 0;
  height: auto;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  padding-top: 12px;
  padding-bottom: 24px;
  position: relative;
  background-color: transparent;
  z-index: 100;
}

.subitems {
  background-color: rgb(34, 45, 58) !important;
  overflow: hidden;
  border-left: 4px solid white;
}
.subitems ul {
  background-color: rgb(34, 45, 58) !important;
}
.subitems li {
  background-color: rgb(34, 45, 58) !important;
  padding: 10px 0px 10px 20px !important;
}
.isActive {
  max-height: 450px;
  transition: max-height 0.25s ease-in;
}
.isInActive {
  max-height: 0px;
  padding: 0px;
  transition: max-height 0.15s ease-out;
}

.icons {
  margin: 0px 10px 0px 0px;
  font-size: 20px;
}
.sidenav-main {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 250px;
  height: 100%;
  text-align: left;
  background: linear-gradient(160deg, #1c2430 0%, #131a22 45%, #10151c 100%);
  padding-top: 0px;
  position: fixed;
  z-index: 10000;
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 18px 0 45px rgba(8, 12, 18, 0.45);
  --pm-cta-gradient: linear-gradient(135deg, #5b6ef5, #7f53ac);
  --pm-cta-gradient-active: linear-gradient(135deg, #5560f2, #7446b3);
  --pm-cta-shadow: 0 12px 24px rgba(91, 110, 245, 0.28);
  --pm-cta-shadow-hover: 0 16px 30px rgba(91, 110, 245, 0.35);
}
.sidenav-main::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at top left, rgba(88, 134, 255, 0.16), transparent 45%);
  pointer-events: none;
}
.brand-header {
  flex: 0 0 auto;
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 26px 18px 14px;
  background: linear-gradient(180deg, rgba(19, 24, 33, 0.96), rgba(19, 24, 33, 0.45));
  backdrop-filter: blur(8px);
}
.brand-logo-frame {
  display: grid;
  place-items: center;
  width: min(200px, 100%);
  height: 82px;
  margin: 0 auto;
}
.brand-logo {
  display: block;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  filter:
    drop-shadow(1px 0 0 rgba(255, 255, 255, 0.92))
    drop-shadow(-1px 0 0 rgba(255, 255, 255, 0.92))
    drop-shadow(0 1px 0 rgba(255, 255, 255, 0.92))
    drop-shadow(0 -1px 0 rgba(255, 255, 255, 0.92))
    drop-shadow(0 8px 16px rgba(0, 0, 0, 0.38));
}
.brand-divider {
  margin-top: 16px;
  height: 1px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.22), rgba(255, 255, 255, 0));
}
.nav-label {
  color: rgba(255, 255, 255, 0.6);
  font-size: 11px;
  padding: 18px 18px 6px;
  text-transform: uppercase;
  letter-spacing: 0.18em;
}
.sidenav-main ul {
  padding: 0 12px 8px;
  list-style-type: none;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  margin: 0; /* Reset default margin */
}

/* Default state for list items */
.sidenav-main li {
  padding: 12px 14px;
  cursor: pointer;
  background-color: transparent; /* Make background transparent by default */
  color: rgba(255, 255, 255, 0.68); /* Default text color */
  border-radius: 14px;
  transition: background-color 0.2s ease, color 0.2s ease, transform 0.2s ease; /* Smooth transitions */
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.menu-item .menu-label {
  flex: 1;
}
.side-menu-close {
  display: none;
}
.sidenav-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.48);
  backdrop-filter: blur(2px);
}

.menu-item .arrows {
  flex: 0 0 20px;
  margin-right: 0;
  transform: none;
}


.cta-link {
  margin: 12px 6px;
  padding: 12px 18px !important;
  border-radius: 14px;
  background: var(--pm-cta-gradient, linear-gradient(135deg, #5b6ef5, #7f53ac));
  box-shadow: var(--pm-cta-shadow, 0 12px 24px rgba(91, 110, 245, 0.28));
  color: #ffffff !important;
  font-weight: 600;
  letter-spacing: 0.3px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.cta-link .arrows {
  color: #ffffff;
  transform: translateY(0);
}

.cta-link:hover {
  transform: translateY(-2px);
  box-shadow: var(--pm-cta-shadow-hover, 0 16px 30px rgba(91, 110, 245, 0.35));
  color: #ffffff;
}

.cta-link.router-link-exact-active,
.cta-link.router-link-exact-active:hover {
  background: var(
    --pm-cta-gradient-active,
    linear-gradient(135deg, #5560f2, #7446b3)
  );
  color: #ffffff;
}

.nav-label + ul {
  margin-top: 4px;
}

.pending-payments-badge {
  background-color: #dc3545;
  color: #ffffff;
  border-radius: 999px;
  font-size: 12px;
  line-height: 1;
  padding: 3px 6px;
  min-width: 20px;
  text-align: center;
  font-weight: 600;
}

/* Hover state for non-active list items */
.sidenav-main li:hover {
  color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, 0.08);
  transform: translateX(2px);
}

/* Active link styles */
.sidenav-main ul .router-link-exact-active {
  background: linear-gradient(135deg, rgba(88, 134, 255, 0.22), rgba(124, 92, 255, 0.1));
  color: white;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.12);
  /* Optional: Add a left border for more emphasis */
  /* border-left: 3px solid #42b983; */ /* Example using Vue green */
  /* If using border-left, adjust padding slightly if needed */
  /* padding-left: 17px; */
}

/* Ensure the active style persists on hover */
.sidenav-main ul .router-link-exact-active:hover {
   background: linear-gradient(135deg, rgba(88, 134, 255, 0.32), rgba(124, 92, 255, 0.14));
   color: white;
}

h3 {
  margin: 40px 0 0;
}

a {
  color: #42b983; /* This might be overridden by li styles, ensure specificity if needed */
}
.slide-enter-active,
.slide-leave-active {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-name: slide;
}

.slide-leave-active {
  animation-direction: reverse;
}

@keyframes slide {
  from {
    opacity: 1;
    transform: translateX(-300px);
  }

  100% {
    opacity: 1;
  }
}

@media only screen and (max-width: 800px) {
  .sidenav-main {
    position: fixed !important;
    top: 0px;
    left: 0px;
    width: min(86vw, 280px);
    max-width: none;
  }
  .brand-header {
    padding: 12px 14px 10px;
  }
  .brand-logo-frame {
    width: 58px;
    height: 58px;
    margin: 0;
  }
  .brand-divider {
    margin-top: 10px;
  }
  .side-menu-close {
    position: absolute;
    top: 18px;
    right: 14px;
    display: grid;
    place-items: center;
    width: 42px;
    height: 42px;
    padding: 0;
    border: 1px solid rgba(255, 255, 255, 0.16);
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.08);
    color: #ffffff;
    font-size: 26px;
    cursor: pointer;
  }
  .main-scrollable {
    padding-top: 4px;
  }
}
</style>
